import { MaintenanceTaskType } from "module/maintenanceTask/types";

export const supportedTypes = [
  MaintenanceTaskType.preventive,
  MaintenanceTaskType.corrective,
  MaintenanceTaskType.carp,
  MaintenanceTaskType.failure,
  MaintenanceTaskType.modification,
];
